import { apiHelper } from '../utils/apiHelper';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/organization-type`;

const headers = {
  "Content-Type": "multipart/form-data",
  "Accept": "application/json"
};

export const fetchOrganizationTypes = (payload) => apiHelper(API_URL, 'GET', payload);
export const createOrganizationType = (payload) => apiHelper(API_URL, 'POST', payload, headers);
export const fetchOrganizationType = (organizationTypeId) => apiHelper(`${API_URL}/${organizationTypeId}`, 'GET');
export const modifyOrganizationType = (payload) => apiHelper(`${API_URL}/${payload.get('id')}`, 'POST', payload, headers);
export const deleteOrganizationTypeApi = (organizationTypeId) => apiHelper(`${API_URL}/${organizationTypeId}`, 'DELETE');
export const changeStatus = (organizationTypeId) => apiHelper(`${API_URL}/change-status/${organizationTypeId}`, 'POST');

